/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect } from 'react';
import { Skeleton } from '@mui/material';
import { compareDataAndNoteIds } from 'components/SpreadsheetNotes/utilities/compareDataAndNoteIds';
import { useGetSpreadsheetNotes } from 'services/hooks/spreadsheetNotes';
import SpreadsheetNoteList from './SpreadsheetNoteList';
import SpreadsheetNotesNotAvailable from './SpreadsheetNotesNotAvailable';
import { SpreadsheetNotesProps } from './types';


const SpreadsheetNotes = ({
  pageType,
  pageTypeKey,
  pageTypeId,
  isApproach,
  notes,
  setNotes,
  handleOnDeleteNote
}: SpreadsheetNotesProps) => {

  const  { data } = useGetSpreadsheetNotes({pageType, pageTypeKey, pageTypeId})

  //   load the notes if they are not already set
  useEffect(() => {
    if (!compareDataAndNoteIds(notes ?? [], data ?? [])) {
      setNotes(data ?? []);
    }
  }, [notes, setNotes, data]);

  if (!isApproach && !pageTypeId) {
    return <Skeleton height="5rem" />;
  }

  // Create a simple SpreadsheetNotesNotAvailable component if it doesn't exist
  const NotAvailableComponent = SpreadsheetNotesNotAvailable || (() => <div>Spreadsheet Notes not available</div>);

  return (
    <>
      {pageTypeId ? (
        <div>
          <SpreadsheetNoteList 
            pageTypeKey={pageTypeKey} 
            pageType={pageType} 
            pageTypeId={pageTypeId} 
            notes={notes}
            setNotes={setNotes}
            handleOnDeleteNote={handleOnDeleteNote}
          />
        </div>
      ) : (
        <NotAvailableComponent />
      )}
    </>
  );
};

export default SpreadsheetNotes;